<template>
  <div class="main">
    <HeaderTitle title="Order">
      <IconOrder color="#14444f" size="w-11 h-11" />
    </HeaderTitle>
    <MainContent>
      <div class="flex gap-3 pt-5">
        <div class="pt-7">
          <SearchInput id="order" @input="search" />
        </div>

        <DatePickerWithLabel
          label="Scene Date"
          v-model:formControlName="sceneFilter"
          @onClickApply="onApplyScene"
        />
        <DatePickerWithLabel
          label="Order Date"
          v-model:formControlName="orderFilter"
          @onClickApply="onApplyOrder"
        />

        <SelectSearchWithLabel
          label="Status"
          :data="status"
          optionsKey="label"
          optionsValue="value"
          placeholder="Filter by status"
          v-model:formControlName="statusFilter"
          @onSelectChange="onApplyStatus"
        />
      </div>

      <div class="pb-5" v-if="!orders.loading">
        <div
          class="overflow-x-auto relative shadow-md rounded-lg"
          v-if="orders.rows?.length != 0"
        >
          <table class="w-full text-sm text-left text-gray-500">
            <thead>
              <tr class="bg-white border-b text-center">
                <th scope="row" class="py-3 px-2">#</th>
                <th scope="row" class="py-3 px-2">Kode Petak</th>
                <th scope="row" class="py-3 px-2">Scene ID</th>
                <th scope="row" class="py-3 px-2">Feature ID</th>
                <th scope="row" class="py-3 px-2">Scene Date</th>
                <th scope="row" class="py-3 px-2">Order Date</th>
                <th scope="row" class="py-3 px-2">Status</th>
                <th scope="row" class="py-3 px-2"></th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-white border-b"
                v-for="(item, index) in orders.rows"
                :key="item.id"
                :class="[
                  { 'hover:bg-lightGray': selected != item.id },
                  { 'bg-gray100': selected == item.id },
                ]"
              >
                <td class="py-3 px-2 text-center">
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-3 px-2">{{ item.kode_petak }}</td>
                <td class="py-3 px-2">{{ item.scene_id }}</td>
                <td class="py-3 px-2">{{ item.feature_id }}</td>
                <td class="py-3 px-2 text-right">
                  {{ date(item.scene_date) }}
                </td>
                <td class="py-3 px-2 text-right">
                  {{ date(item.order_date) }}
                </td>
                <td class="py-3 px-2">
                  <div class="flex items-center justify-center">
                    <span
                      class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-green-900 dark:text-green-300"
                      v-if="item.status == 'success'"
                    >
                      SUCCESS
                    </span>
                    <span
                      class="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-yellow-900 dark:text-yellow-300"
                      v-if="item.status == 'pending'"
                    >
                      PENDING
                    </span>
                  </div>
                </td>
                <td class="py-3 px-2">
                  <div class="flex items-center justify-center">
                    <button
                      class="bg-blue-800 hover:bg-blue-900 rounded-full p-1"
                      @click="onClick(item)"
                    >
                      <IconEye color="white" size="w-3 h-3" />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>
      </div>

      <LoadingLottie v-if="orders.loading" />
      <div class="flex justify-center" v-if="orders.rows?.length == 0">
        <NoData size="w-full md:w-5/12" />
      </div>
      <AlertErrorComponent
        v-if="orders.error"
        :message="orders.error.response.data.message"
      />
    </MainContent>
  </div>

  <div
    class="flex-none ease-in-out duration-300 max-h-full z-30 h-full right-0 absolute md:block md:static"
    :class="{ 'w-0 ': !open, 'width-sidebar': open }"
  >
    <div
      class="absolute ease-in-out flex-row bg-greenSide h-full pt-2"
      :class="{ 'w-0 ': !open, 'width-sidebar': open }"
    >
      <div
        class="absolute z-50 p-1 top-2/4 rounded-full bg-amber hover:cursor-pointer hover:bg-amber500"
        :class="{ 'right-0 hidden': !open, 'right-[20.3rem]': open }"
        @click="close"
      >
        <svg
          class="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
      </div>

      <div v-show="open">
        <h1 class="text-1xl font-bold text-white pb-3 px-4">Geofence</h1>
        <div
          class="flex justify-center items-center bg-gray-300 h-[89vh]"
          v-if="orders.loading"
        >
          <LoadingLoad size="w-16 h-16" />
        </div>

        <div v-show="!orders.loading">
          <div id="mapdetail" class="w-full h-[89vh] z-40"></div>
        </div>
      </div>

      <div
        v-if="open"
        class="absolute w-full bg-greenPrimary bottom-0 pb-[5px] px-2 items-center space-x-1 border-t border-greenPrimary"
      >
        <kbd
          class="px-1 py-[2px] text-[0.5rem] font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg dark:bg-gray-600 dark:text-gray-100 dark:border-gray-500"
          >Esc</kbd
        >
        <span class="text-white text-[0.8rem]">exit</span>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerWithLabel from "@/components/DatePickerWithLabel.vue";
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconOrder from "@/components/icons/IconOrder.vue";
import MainContent from "@/components/MainContent.vue";
import SelectSearchWithLabel from "@/components/SelectSearchWithLabel.vue";
import {
  useOrderStore,
  usesgnksoFeaturesStore,
  useSidebarStore,
} from "@/store";
import { computed, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import moment from "moment";
import PaginationComponent from "@/components/PaginationComponent.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import NoData from "@/components/NoData.vue";
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import L from "leaflet";
import LoadingLoad from "@/components/LoadingLoad.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  components: {
    HeaderTitle,
    IconOrder,
    MainContent,
    DatePickerWithLabel,
    SelectSearchWithLabel,
    IconEye,
    PaginationComponent,
    LoadingLottie,
    NoData,
    AlertErrorComponent,
    LoadingLoad,
    SearchInput,
  },
  setup() {
    const sidebarStore = useSidebarStore();
    const { selected } = storeToRefs(sidebarStore);
    const orderStore = useOrderStore();
    const { orders } = storeToRefs(orderStore);
    const sgnksofeaturesStore = usesgnksoFeaturesStore();

    const offset = ref(0);
    const limit = ref(50);
    const length = ref(0);
    const page = ref(1);

    const open = computed(() => sidebarStore.open);

    const sceneFilter = ref(null);
    const orderFilter = ref(null);
    const statusFilter = ref("");
    const q = ref(null);

    const status = ref([
      { value: "Success", label: "success" },
      { value: "Pending", label: "pending" },
    ]);

    const mapdetail = ref(null);
    const center = ref([-1.476796, 121.001893]);
    const zoom = ref(5);
    const shapeLayer = ref(null);

    const createMaps = () => {
      mapdetail.value = L.map("mapdetail", { zoomAnimation: false }).setView(
        center.value,
        zoom.value
      );
      L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
        {
          minZoom: 5,
          attribution: "Citra Satelite © 2025",
        }
      ).addTo(mapdetail.value);
    };

    const onEachFeature = async (feature, layer) => {
      if (feature.properties) {
        const div = document.createElement("div");

        const info = document.createElement("div");
        info.setAttribute("class", "flex justify-between mt-2");

        const table = document.createElement("table");
        info.appendChild(table);

        for (var key in feature.properties) {
          const row = document.createElement("tr");
          table.appendChild(row);

          const cell1 = document.createElement("td");
          const cell2 = document.createElement("td");
          cell2.setAttribute("class", "px-2");
          const cell3 = document.createElement("td");

          const textNode1 = document.createTextNode(key);
          const textNode2 = document.createTextNode(":");
          const textNode3 = document.createTextNode(feature.properties[key]);
          cell1.appendChild(textNode1);
          cell2.appendChild(textNode2);
          cell3.appendChild(textNode3);
          row.appendChild(cell1);
          row.appendChild(cell2);
          row.appendChild(cell3);
        }

        div.appendChild(info);
        layer.bindPopup(div, {
          maxHeight: 300,
          maxWidth: 280,
        });
      }
    };

    const createGeofence = async (featureid) => {
      await sgnksofeaturesStore.getByFeatureid(featureid);
      const features = sgnksofeaturesStore.featurebyid;

      shapeLayer.value = new L.Shapefile(features, {
        onEachFeature: onEachFeature,
      });
      mapdetail.value.fitBounds(shapeLayer.value.getBounds());
      shapeLayer.value.addTo(mapdetail.value);
    };

    const onClick = async (value) => {
      selected.value = value.id;
      sidebarStore.$patch(async (state) => {
        if (!state.open) {
          state.open = !state.open;
        }

        if (state.id != value.id) {
          state.id = value.id;
          state.data = value;
        }

        if (mapdetail.value.hasLayer(shapeLayer.value)) {
          await mapdetail.value.removeLayer(shapeLayer.value);
        }

        createGeofence(value.feature_id);
      });
    };

    const changePage = async (value) => {
      sidebarStore.open = false;
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataParams = { offset: offset.value };

      if (q.value != null || q.value != "") {
        dataParams = {
          ...dataParams,
          q: q.value,
        };
      }

      if (statusFilter.value != null || statusFilter.value != "") {
        dataParams = {
          ...dataParams,
          status: statusFilter.value,
        };
      }

      if (orderFilter.value != null && sceneFilter.value == null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value != null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value == null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else {
        dataParams;
      }

      await orderStore.getAllOrder(dataParams);
      length.value = orders.value.count;
    };

    const getAllOrder = async () => {
      await orderStore.getAllOrder({
        limit: limit.value,
        offset: offset.value,
      });
      length.value = orders.value.count;
    };

    const date = (date) => {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    };

    const onApplyScene = async () => {
      sidebarStore.open = false;
      offset.value = 0;
      page.value = 1;
      let dataParams = {
        offset: offset.value,
      };

      if (q.value != null || q.value != "") {
        dataParams = {
          ...dataParams,
          q: q.value,
        };
      }

      if (statusFilter.value != null || statusFilter.value != "") {
        dataParams = {
          ...dataParams,
          status: statusFilter.value,
        };
      }

      if (orderFilter.value != null && sceneFilter.value == null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value != null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value == null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else {
        dataParams;
      }

      await orderStore.getAllOrder(dataParams);
      length.value = orders.value.count;
    };

    const onApplyOrder = async () => {
      sidebarStore.open = false;
      offset.value = 0;
      page.value = 1;
      let dataParams = {
        offset: offset.value,
      };

      if (q.value != null || q.value != "") {
        dataParams = {
          ...dataParams,
          q: q.value,
        };
      }

      if (statusFilter.value != null || statusFilter.value != "") {
        dataParams = {
          ...dataParams,
          status: statusFilter.value,
        };
      }

      if (orderFilter.value != null && sceneFilter.value == null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value != null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value == null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else {
        dataParams;
      }

      await orderStore.getAllOrder(dataParams);
      length.value = orders.value.count;
    };

    const onApplyStatus = async () => {
      sidebarStore.open = false;
      offset.value = 0;
      page.value = 1;
      let dataParams = {
        offset: offset.value,
      };

      if (q.value != null || q.value != "") {
        dataParams = {
          ...dataParams,
          q: q.value,
        };
      }

      if (statusFilter.value != null || statusFilter.value != "") {
        dataParams = {
          ...dataParams,
          status: statusFilter.value,
        };
      }

      if (orderFilter.value != null && sceneFilter.value == null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value != null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value == null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else {
        dataParams;
      }

      await orderStore.getAllOrder(dataParams);
      length.value = orders.value.count;
    };

    const keyboardListen = (event) => {
      if (event.key === "Escape") {
        sidebarStore.$reset();
      }
    };

    onMounted(async () => {
      sidebarStore.open = true;
      await getAllOrder();
      window.addEventListener("keydown", keyboardListen);
      createMaps();
    });

    const close = async () => {
      if (mapdetail.value.hasLayer(shapeLayer.value)) {
        await mapdetail.value.removeLayer(shapeLayer.value);
      }
      sidebarStore.$reset();
    };

    const search = async (value) => {
      offset.value = 0;
      page.value = 1;
      q.value = value.target.value;

      let dataParams = { offset: offset.value, q: value.target.value };

      if (statusFilter.value != null || statusFilter.value != "") {
        dataParams = {
          ...dataParams,
          status: statusFilter.value,
        };
      }

      if (orderFilter.value != null && sceneFilter.value == null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value != null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          orderdate1: moment(orderFilter.value[0]).format("YYYY-MM-DD"),
          orderdate2: moment(orderFilter.value[1]).format("YYYY-MM-DD"),
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else if (orderFilter.value == null && sceneFilter.value != null) {
        dataParams = {
          ...dataParams,
          scenedate1: moment(sceneFilter.value[0]).format("YYYY-MM-DD"),
          scenedate2: moment(sceneFilter.value[1]).format("YYYY-MM-DD"),
        };
      } else {
        dataParams;
      }

      await orderStore.getAllOrder(dataParams);
      length.value = orders.value.count;
    };

    const formatNum = (num) => {
      return num.toLocaleString("id-ID");
    };

    return {
      status,
      onClick,
      limit,
      page,
      length,
      selected,
      orders,
      date,
      changePage,
      onApplyScene,
      onApplyOrder,
      sceneFilter,
      orderFilter,
      statusFilter,
      onApplyStatus,
      open,
      close,
      search,
      formatNum,
    };
  },
};
</script>
<style></style>
